<template>
  <div id="department" class="hw-wrap style1 bg-albastor">
    <div class="container ptb-100">
      <div
        class="hw-img-one bg-f"
        data-aos="fade-left"
        data-aos-duration="1200"
        data-aos-delay="200"
      ></div>
      <div
        class="row"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="200"
      >
        <div class="col-lg-6">
          <div class="content-title style1">
            <span>How It Works</span>
            <h2>
              Take Care Of The Health And Well-Being Of You And Your Family
            </h2>
          </div>
        </div>

        <div class="col-xl-10">
          <div class="hw-content">
            <ul class="nav nav-tabs hw-tablist" role="tablist">
              <li class="nav-item">
                <button
                  class="tab-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_1"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-dental-implant"></i> Dental Implants
                </button>
              </li>

              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_2"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-tooth-whitening"></i> Teeth Whitening
                </button>
              </li>

              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_3"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-tooth-brush"></i> Brush Teeth
                </button>
              </li>

              <li class="nav-item">
                <button
                  class="tab-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab_4"
                  type="button"
                  role="tab"
                >
                  <i class="flaticon-dental-care"></i> Dental Care
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="tab-content hw-tab-content">
            <div class="tab-pane fade show active" id="tab_1" role="tabpanel">
              <h5>Dental Implants Repair And Teeth Services</h5>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a moreor less
                normal distribution of letters, as opposed to using.
              </p>
              <ul class="content-feature-list style4 list-style">
                <li>
                  <span><i class="ri-check-double-line"></i></span> Stop
                  worrying, we will take care of your physical problems
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span>Challenges
                  with dental insurance can take valuable time
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span>Dental
                  insurance issues are the most important that dentists face
                </li>
              </ul>
            </div>
            <div class="tab-pane fade" id="tab_2" role="tabpanel">
              <h5>Teeth Whitening & Scalling</h5>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a moreor less
                normal distribution of letters, as opposed to using.
              </p>
              <ul class="content-feature-list style4 list-style">
                <li>
                  <span><i class="ri-check-double-line"></i></span>Challenges
                  with dental insurance can take valuable time
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span> Stop
                  worrying, we will take care of your physical problems
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span>Dental
                  insurance issues are the most important that dentists face
                </li>
              </ul>
            </div>
            <div class="tab-pane fade" id="tab_3" role="tabpanel">
              <h5>Brush Teeth &amp; Root Canal</h5>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a moreor less
                normal distribution of letters, as opposed to using.
              </p>
              <ul class="content-feature-list style4 list-style">
                <li>
                  <span><i class="ri-check-double-line"></i></span> Stop
                  worrying, we will take care of your physical problems
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span>Challenges
                  with dental insurance can take valuable time
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span>Dental
                  insurance issues are the most important that dentists face
                </li>
              </ul>
            </div>
            <div class="tab-pane fade" id="tab_4" role="tabpanel">
              <h5>Complete Dental Solution</h5>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a moreor less
                normal distribution of letters, as opposed to using.
              </p>
              <ul class="content-feature-list style4 list-style">
                <li>
                  <span><i class="ri-check-double-line"></i></span>Dental
                  insurance issues are the most important that dentists face
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span>Challenges
                  with dental insurance can take valuable time
                </li>
                <li>
                  <span><i class="ri-check-double-line"></i></span> Stop
                  worrying, we will take care of your physical problems
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowItWorks",
};
</script>